export const exact = {
  oAuthFlowHelp: "Meinen Account autorisieren"
};